import { createStyles } from '@zn-material-ui'

export default createStyles({
  login: {
    display: 'flex',
    height: '100%',
    flexDirection: 'row',
    minHeight: 720,
  },
  dialogSpan: {
    color: '#000000',
    fontSize: '20px',
  }
})
